export { default } from './MainHeaderContent';
